import './css/dashboardtable.css';
import './css/editform.css';
import React, { useState,useEffect} from "react";
import axios from '../../config/index';
import { Link, useNavigate } from 'react-router-dom';






function AddBlog(){


        
    useEffect(() => {
        axios
    .get('session')
    .then((res) => {
        if (res.data.valid) {

            if(res.data.type == "admin"){
            }else{
                navigate('/admin-login');
            }

        } else {

        }
    })
    .catch((err) => console.log(err));
    },[]);





    const navigate = useNavigate();


    
    const [header, setHeader] = useState("");
    const [para, setPara] = useState("");
    const [img, setImg] = useState("");


    const handleSubmit = (event) => {
        event.preventDefault();

        let Loading = document.querySelector(".loading-screen"); 
        Loading.classList.add("active");

        const data = new FormData();


        data.append("header", header || "");
        data.append("para", para || "");

        if (img) {
            data.append("img", img);
        }
    
    
        const config = {
        headers: {
            "Content-Type": "multipart/form-data",
        },
        };
    
        axios
        .post("/add-blog", data, config)
        .then((response) => {
            
            Loading.classList.remove("active");

            let alertS = document.querySelector(".alert-success"); 
            alertS.classList.add("active");


            setTimeout(() => {
                alertS.classList.remove("active");
            }, 3000);


        })
        .catch((error) => {
            
            Loading.classList.remove("active");

            let alertD = document.querySelector(".alert-danger"); 
            alertD.classList.add("active");
            setTimeout(() => {
                alertD.classList.remove("active");
            }, 3000);
            console.log(error);
        });
    };
    


    axios.defaults.withCredentials = true;



    const getIfLogin= ()=>{
        
    axios
    .get('session')
    .then((res) => {
        if (!res.data.valid) {
            navigate('/admin-login');

        }
        
    })
    .catch((err) => console.log(err));

    }


    const [AllBlogs, setAllBlogs] = useState([]);

    
    const getAllBlogs = ()=>{
        axios.post('AllItems', {
            table: 'blogs',
        })
        .then((res) => {
            if (res.data) {
                console.log(res.data)
                setAllBlogs(res.data);
            } else {
                console.log("Error happened");
            }
        })
        .catch((err) => console.log(err));
    };
    



    useEffect(() => {
        getIfLogin();
        getAllBlogs();
    }, []);
    




    

    return(
        <>

                    <div className='loading-screen'>
                            <div class="loader">
                                <div class="outer"></div>
                                <div class="middle"></div>
                                <div class="inner"></div>
                            </div>

                        </div>
            <section className='dashboard'>



                <div className='edit-form'>

                    <div className='alert-success'>
                        <h1> Data Added successfully <i class="las la-check-circle"></i></h1>
                    </div>

                    <div className='alert-danger'>
                        <h1> Failed To Add Data <i class="las la-exclamation-triangle"></i></h1>

                    </div>

                    <h1> Add new Blog </h1>

                    <form onSubmit={handleSubmit}>

                        
                    <div className='input'>
                        <label> Blog Header  </label>
                        <input  onChange={(event) => setHeader(event.target.value)} type='text' required="required"  maxLength="250" name='header'/>
                    </div>



                    <div className='input'>
                        <label> Text  </label>
                        <textarea  onChange={(event) => setPara(event.target.value)} type='text' required="required"  name='para'>
                            
                        </textarea>
                    </div>

                    <div className='input'>
                        <label> Image  </label>
                        <input onChange={(event) => setImg(event.target.files[0])} type='file' name="img" accept="image/*"/>
                    </div>

                
                    <button type='submit'> Save </button>

                    </form>
                </div>
            </section>
        
        </>
    )
}

export default AddBlog;